const enquiryStatusConfig = {
    draft: {
        text: 'Entwurf',
        color: 'grey-3',
        textColor: 'primary',
    },
    open: {
        text: 'Offen',
        color: 'grey-3',
        textColor: 'primary',
    },
    completed: {
        text: 'In Prüfung',
        color: 'grey-3',
        textColor: 'positive',
    },
    processed: {
        text: 'Abgeschlossen',
        color: 'grey-3',
        textColor: 'positive',
    },
    expired: {
        text: 'Abgelaufen',
        color: 'grey-3',
        textColor: 'negative',
    },
    aborted: {
        text: 'Abgebrochen',
        color: 'grey-3',
        textColor: 'negative',
    },
    archived: {
        text: 'Archiviert',
        color: 'grey-3',
        textColor: 'positive',
    },
};

export default enquiryStatusConfig;
